import { useApi } from '@backstage/core-plugin-api';
import useAsyncRetry from 'react-use/esm/useAsyncRetry';
import { mcpChatApiRef } from '../api';
import { MCPServer, Tool } from '../types';

export interface UseAvailableToolsReturn {
  availableTools: Tool[];
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useAvailableTools = (
  mcpServers: MCPServer[],
): UseAvailableToolsReturn => {
  const mcpChatApi = useApi(mcpChatApiRef);

  const {
    value: availableTools,
    loading: isLoading,
    error,
    retry: refetch,
  } = useAsyncRetry(async () => {
    // Only fetch tools if there are MCP servers available
    if (!mcpServers || mcpServers.length === 0) {
      return [];
    }

    const toolsResponse = await mcpChatApi.getAvailableTools();
    return toolsResponse.availableTools;
  }, [mcpChatApi, mcpServers]);

  const getErrorMessage = () => {
    if (!error) return null;
    if (error instanceof Error) return error.message;
    return 'Failed to fetch available tools';
  };

  return {
    availableTools: availableTools || [],
    isLoading,
    error: getErrorMessage(),
    refetch,
  };
};
